import * as yup from 'yup';
import 'yup-phone';

const passwordSchema = yup.object().shape({
  currentPassword: yup.string().required('Mandatory Current password field!')
});
export { passwordSchema };
